<template>
    <div>
        <left-column style="position: relative" class="stepRoofSize">
            <GmapMap
                :center="{lat:$storage.state.summary.address.lat, lng:$storage.state.summary.address.lng}"
                :zoom="zoom"
                map-type-id="satellite"
                style="width: 100%; height: 100%"
                ref="gMap"
                id="gMap"
                :tilt = "0"
                :options="{
                   zoomControl: false,
                   mapTypeControl: false,
                   scaleControl: false,
                   streetViewControl: false,
                   rotateControl: false,
                   fullscreenControl: false,
                   disableDefaultUI: true,

                }"
                >
            </GmapMap>
            <div class="wgCalcMPanel" v-if="polygonInstance && !error_message">
                <span class="bo_r">{{measurements.roofSize}} m²</span>
                <span class="bo_r">{{measurements.panels}} {{$t('panels')}}</span>
                <button @click="enableDraw">
                    <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 5.48L7.519 2M4 5.48l3.519 3.482M4 5.48s4.479-1.582 7.358.316c2.879 1.899 2.56 9.81-5.758 7.911" stroke="currentColor" stroke-linecap="round"></path></svg><span class="label">{{$t('undo')}}</span></button>
            </div>
        </left-column>
        <right-column>
            <h2>{{$t('step_size.heading')}}</h2>
            <p>{{$t('step_size.subheading')}}</p>
            <v-alert type="error" v-if="error_message" >
                <span v-html="error_message"></span>

            </v-alert>
        </right-column>
    </div>
</template>
<script>
import html2canvas from "html2canvas";
import LeftColumn from "../LeftColumn";
import RightColumn from "../RightColumn";
import {gmapApi} from 'vue2-google-maps-withscopedautocomp';
import { getRoofMeasurements, PANEL_MIN, PANEL_MAX } from '@/helpers'
import steps from "./mixins/steps";
export const STEP_KEY = 'roofSize'

const polygonOptions = {
    editable: true,
    clickable: true,
    fillColor: "#D43AAC",
    strokeColor: typeof window.wgCalc?.themes?.primary !== 'undefined' ?  window.wgCalc.themes.primary :  '#FAA048',
    fillOpacity: 0.2,
    strokeWeight: 5,
};


export const makeScreenshot = function(element, posX, posY, width, height){
    return new Promise ((resolve,reject )=> {

        html2canvas(document.querySelector(element), {
            useCORS: true,
            allowTaint: false,
        }).then((canvas) => {
            const context = canvas.getContext("2d");
            const imageData = context.getImageData(
                posX,
                posY,
                canvas.width,
                canvas.height
            ).data;
            const outputCanvas = document.createElement("canvas");
            const outputContext = outputCanvas.getContext("2d");
            outputCanvas.width = canvas.width;
            outputCanvas.height = canvas.height;

            const outputIData = outputContext.createImageData(
                canvas.width,
                canvas.height
            );
            outputIData.data.set(imageData);
            outputContext.putImageData(outputIData, 0, 0);
            resolve(outputCanvas.toDataURL('image/jpeg',0.7));
        });
    });
}

let overlayListener = null;
let mouseUpListener = null;

export default {
    name:'StepRoofSize',
    mixins:[steps],
    components: {
        LeftColumn,
        RightColumn
    },
    data(){
        return {
            zoom: 20,
            drawingManager : null,
            polygonInstance:null,
            measurements:{
                panels:0,
                roofSize: 0,
            },
            error_message: false
        }
    },
    computed:{
        mapCenter(){
            return {
                lat: this.$storage.state.summary.address.lat,
                lng: this.$storage.state.summary.address.lng
            }
        },
        mapCenterJson(){
            return JSON.stringify(this.mapCenter)
        },
        google: gmapApi,

        isValid:{
            get: function(){
                return this.polygonInstance != null  && !this.error_message ? true : false;
            }

        }
    },
    watch:{
        mapCenterJson(){
            //this.$refs.gMap.setCenter(this.mapCenter);
        },
        polygonInstance( newVal ){
            if(newVal){
                this.handlePolygon(newVal)
                if (!mouseUpListener) {
                    mouseUpListener = this.google.maps.event.addListener(
                        newVal,
                        "mouseup",
                        (event) => {
                            this.handlePolygon(this.polygonInstance);
                        }
                    );
                }
            }else{
                this.resetPolygon();
            }


        }
    },
    mounted() {

        this.$refs.gMap.$mapPromise.then((map) => {
            this.drawingManager = new this.google.maps.drawing.DrawingManager({
                drawingMode: this.google.maps.drawing.OverlayType.POLYGON,
                drawingControl: true,
                drawingControlOptions: {
                    position: this.google.maps.ControlPosition.TOP_LEFT,
                    drawingModes: [this.google.maps.drawing.OverlayType.POLYGON],
                },
                polygonOptions: polygonOptions,
            });
            this.drawingManager.setMap(map);
            overlayListener = this.google.maps.event.addListener(
                this.drawingManager,
                "overlaycomplete",
                (event) => {
                    if (event.overlay instanceof this.google.maps.Polygon) {
                        this.polygonInstance = event.overlay;
                    }
                },
            );
            if(this.$storage.state.polygon){
                this.polygonInstance = this.$storage.state.polygon;
                this.polygonInstance.setMap(map);
            }
        })

    },
    destroyed() {
        if(overlayListener){
            this.google.maps.event.removeListener(overlayListener);
        }
        this.resetPolygon();
    },
    methods:{
        async applyNext(){
            if(this.$storage.state.passed.indexOf(STEP_KEY)<=0){
                this.$storage.state.passed.push(STEP_KEY);
            }

            this.$storage.state.summary.snapshot = await makeScreenshot('#gMap',0,0,600,600);
            this.$storage.state.polygon = this.polygonInstance;
            this.$storage.state.summary.panels.amount = this.measurements.panels;
            this.$storage.state.summary.roof.size = this.measurements.roofSize;
            this.$storage.state.currentStep = this.$storage.state.steps[this.$storage.state.steps.indexOf(this.$storage.state.currentStep)+1];
        },
        resetDraw(){
            if(this.drawingManager){
                this.drawingManager.setMap(null);
            }
        },
        enableDraw() {
            if (this.drawingManager) {

                this.$refs.gMap.$mapPromise.then((map) => {
                    this.drawingManager.setMap(map);
                    if (this.polygonInstance) {
                        this.polygonInstance.setMap(null);
                    }
                    this.polygonInstance = null;
                })
            }
        },
        resetPolygon(){
            if(mouseUpListener){
                this.google.maps.event.removeListener(mouseUpListener);
                mouseUpListener  = null;
            }
        },
        handlePolygon(polygon){
            this.error_message  = '';
            this.measurements = {panels: 0, roofSize: 0};
            if(polygon){
                const mesure = getRoofMeasurements(polygon);
                if(mesure.panels < PANEL_MIN || mesure.panels > PANEL_MAX){
                    this.error_message = this.$i18n.t('step_size.not_suit');

                }else{
                    this.measurements = mesure;
                }

                this.resetDraw();
            }
        }
    }

}
</script>
<style lang="scss">
.wgCalc{
    &MPanel{
        width: 80%;
        margin: auto;
        border-radius: 3px;
        padding: 0.75rem 1rem;
        display: grid;
        grid-template-columns: 1fr 2fr 1fr;
        text-align: center;
        -webkit-box-align: center;
        align-items: center;
        background-color: white;
        position: absolute;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%);
        span{
            &.bo_r{
                border-right: 1px solid rgb(223, 223, 223);
            }
        }
        button{
            border: none;
            background: none;
            padding: 0.25rem;
            display: grid;
            grid-template-columns: 1fr 1fr;
            justify-items: center;
            align-items: center;
            cursor: pointer;
        }

        @media only screen and (max-width: 755px){
            bottom: 90px;
        }
    }
    &LeftCol{
        @media only screen and (max-width: 755px){
            &.stepRoofSize{
                height: 60vh;
            }
        }
    }
}
</style>
